module.exports = __webpack_public_path__ + "img/call.7c5fb3a7.svg";